export default "__VITE_ASSET__0xXD30VZ__"